import styled from "styled-components";
import attributes from "../utils/constants/attributes";
import { HTMLTag } from "./utils/types";

export const A = styled.a<HTMLTag>(...attributes);
export const Abbr = styled.abbr<HTMLTag>(...attributes);
export const Address = styled.address<HTMLTag>(...attributes);
export const Area = styled.area<HTMLTag>(...attributes);
export const Article = styled.article<HTMLTag>(...attributes);
export const Aside = styled.aside<HTMLTag>(...attributes);
export const Audio = styled.audio<HTMLTag>(...attributes);
export const B = styled.b<HTMLTag>(...attributes);
export const Bdi = styled.bdi<HTMLTag>(...attributes);
export const Bdo = styled.bdo<HTMLTag>(...attributes);
export const Blockquote = styled.blockquote<HTMLTag>(...attributes);
export const Body = styled.body<HTMLTag>(...attributes);
export const Br = styled.br<HTMLTag>(...attributes);
export const Button = styled.button<HTMLTag>(...attributes);
export const Canvas = styled.canvas<HTMLTag>(...attributes);
export const Caption = styled.caption<HTMLTag>(...attributes);
export const Cite = styled.cite<HTMLTag>(...attributes);
export const Code = styled.code<HTMLTag>(...attributes);
export const Col = styled.col<HTMLTag>(...attributes);
export const Colgroup = styled.colgroup<HTMLTag>(...attributes);
export const Data = styled.data<HTMLTag>(...attributes);
export const Datalist = styled.datalist<HTMLTag>(...attributes);
export const Dd = styled.dd<HTMLTag>(...attributes);
export const Del = styled.del<HTMLTag>(...attributes);
export const Details = styled.details<HTMLTag>(...attributes);
export const Dfn = styled.dfn<HTMLTag>(...attributes);
export const Dialog = styled.dialog<HTMLTag>(...attributes);
export const Div = styled.div<HTMLTag>(...attributes);
export const Dl = styled.dl<HTMLTag>(...attributes);
export const Dt = styled.dt<HTMLTag>(...attributes);
export const Em = styled.em<HTMLTag>(...attributes);
export const Embed = styled.embed<HTMLTag>(...attributes);
export const Fieldset = styled.fieldset<HTMLTag>(...attributes);
export const Figcaption = styled.figcaption<HTMLTag>(...attributes);
export const Figure = styled.figure<HTMLTag>(...attributes);
export const Footer = styled.footer<HTMLTag>(...attributes);
export const Form = styled.form<HTMLTag>(...attributes);
export const H1 = styled.h1<HTMLTag>(...attributes);
export const H2 = styled.h2<HTMLTag>(...attributes);
export const H3 = styled.h3<HTMLTag>(...attributes);
export const H4 = styled.h4<HTMLTag>(...attributes);
export const H5 = styled.h5<HTMLTag>(...attributes);
export const H6 = styled.h6<HTMLTag>(...attributes);
export const Header = styled.header<HTMLTag>(...attributes);
export const Hr = styled.hr<HTMLTag>(...attributes);
export const I = styled.i<HTMLTag>(...attributes);
export const Img = styled.img<HTMLTag>(...attributes);
export const Input = styled.input<HTMLTag>(...attributes);
export const Ins = styled.ins<HTMLTag>(...attributes);
export const Kbd = styled.kbd<HTMLTag>(...attributes);
export const Label = styled.label<HTMLTag>(...attributes);
export const Legend = styled.legend<HTMLTag>(...attributes);
export const Li = styled.li<HTMLTag>(...attributes);
export const Link = styled.link<HTMLTag>(...attributes);
export const Main = styled.main<HTMLTag>(...attributes);
export const Map = styled.map<HTMLTag>(...attributes);
export const Mark = styled.mark<HTMLTag>(...attributes);
export const Meta = styled.meta<HTMLTag>(...attributes);
export const Meter = styled.meter<HTMLTag>(...attributes);
export const Nav = styled.nav<HTMLTag>(...attributes);
export const Noscript = styled.noscript<HTMLTag>(...attributes);
export const Object = styled.object<HTMLTag>(...attributes);
export const Ol = styled.ol<HTMLTag>(...attributes);
export const Optgroup = styled.optgroup<HTMLTag>(...attributes);
export const Option = styled.option<HTMLTag>(...attributes);
export const Output = styled.output<HTMLTag>(...attributes);
export const P = styled.p<HTMLTag>(...attributes);
export const Param = styled.param<HTMLTag>(...attributes);
export const Picture = styled.picture<HTMLTag>(...attributes);
export const Pre = styled.pre<HTMLTag>(...attributes);
export const Progress = styled.progress<HTMLTag>(...attributes);
export const Q = styled.q<HTMLTag>(...attributes);
export const Rp = styled.rp<HTMLTag>(...attributes);
export const Rt = styled.rt<HTMLTag>(...attributes);
export const Ruby = styled.ruby<HTMLTag>(...attributes);
export const S = styled.s<HTMLTag>(...attributes);
export const Samp = styled.samp<HTMLTag>(...attributes);
export const Section = styled.section<HTMLTag>(...attributes);
export const Select = styled.select<HTMLTag>(...attributes);
export const Small = styled.small<HTMLTag>(...attributes);
export const Source = styled.source<HTMLTag>(...attributes);
export const Span = styled.span<HTMLTag>(...attributes);
export const Strong = styled.strong<HTMLTag>(...attributes);
export const Style = styled.style<HTMLTag>(...attributes);
export const Sub = styled.sub<HTMLTag>(...attributes);
export const Summary = styled.summary<HTMLTag>(...attributes);
export const Sup = styled.sup<HTMLTag>(...attributes);
export const Svg = styled.svg<HTMLTag>(...attributes);
export const Table = styled.table<HTMLTag>(...attributes);
export const Tbody = styled.tbody<HTMLTag>(...attributes);
export const Td = styled.td<HTMLTag>(...attributes);
// export const Template = styled.template<HTMLTag>(...attributes); // cant defined
export const Textarea = styled.textarea<HTMLTag>(...attributes);
export const Tfoot = styled.tfoot<HTMLTag>(...attributes);
export const Th = styled.th<HTMLTag>(...attributes);
export const Thead = styled.thead<HTMLTag>(...attributes);
export const Time = styled.time<HTMLTag>(...attributes);
export const Tr = styled.tr<HTMLTag>(...attributes);
export const Track = styled.track<HTMLTag>(...attributes);
export const U = styled.u<HTMLTag>(...attributes);
export const Ul = styled.ul<HTMLTag>(...attributes);
export const Var = styled.var<HTMLTag>(...attributes);
export const Video = styled.video<HTMLTag>(...attributes);
export const Wbr = styled.wbr<HTMLTag>(...attributes);
